<style scoped>
</style>
<template>
    <el-dialog
        :title="orderId ? '编辑订单' : '新建订单' "
        width="400px"
        :visible.sync="showDialog"
        @closed="refeshRule"
        class="order-dialog"
    >
        <el-form ref="orderForm" label-width="80px" :model="order" :rules="rules"></el-form>

        <div slot="footer" class="dialog-footer">
            <el-button
                v-if="orderId"
                type="primary"
                size="small"
                class="op-button"
                @click="save()"
            >修改</el-button>
            <el-button
                v-if="!orderId"
                type="primary"
                size="small"
                class="op-button"
                @click="save()"
            >新增</el-button>
        </div>
    </el-dialog>
</template>
<script>
export default {
    props: {
        orderId: { type: Number, default: 0 },
        show: { type: Boolean, default: false },
        added: { type: Function, default: null },
        isRoot: { type: Boolean, default: false },
    },
    data() {
        return {
            showDialog: false,
            shops: null,
            order: {},
            rules: {
                fullName: [
                    {
                        required: true,
                        message: "请输入客户名称",
                        trigger: "blur",
                    },
                    {
                        min: 2,
                        max: 128,
                        message: "长度在 2 到 128 个字符",
                        trigger: "blur",
                    },
                ],

                shopId: [
                    {
                        required: true,
                        message: "请选择所属店铺",
                        trigger: "blur",
                    },
                ],
            },
        };
    },
    methods: {
        getOrder() {
            let _this = this;

            _this.$http.post(
                [
                    _this.isRoot
                        ? "alibaba/order/get"
                        : "alibaba/order/getMyself",
                    { id: _this.orderId },
                ],
                [
                    function (data) {
                        _this.order = {
                            id: data.id,
                        };

                        _this.showDialog = true;
                    },
                ],
                ".buyer-dialog"
            );
        },
        refeshRule() {
            this.$refs["orderForm"].resetFields();
            this.$emit("update:show", false);
        },
        save() {
            let _this = this;
            _this.$refs["orderForm"].validate().then(function () {
                _this.dosave();
            });
        },
        dosave() {
            let _this = this;

            _this.$http.post(
                [
                    _this.isRoot
                        ? "alibaba/order/save"
                        : "alibaba/order/saveMyself",
                    _this.order,
                ],
                [
                    function (data) {
                        if (_this.added) {
                            _this.showDialog = false;
                            _this.added();
                        }
                    },
                ],
                ".prdocut-dloaig"
            );
        },
    },
    watch: {
        show(val) {
            if (val && this.orderId) {
                this.getOrder();
            } else {
                this.order = {};
                this.showDialog = val;
            }
        },
    },
};
</script>